import {ArtifactType} from '../types/enums';
import {ReportStatus} from '../utils/schemas/reports';

import type {TemperatureKey} from '../types/temperature';

export const SUPPORT_EMAIL = 'support@qii.ai';

export const TEXTAREA_DEFAULT_MAX = 500;

export const MAP_DEFAULTS = {
  maxZoom: 21,
  maxNativeZoom: 18,
  minZoom: 3,
  scRadius: 60,
  animDuration: 1,
  shouldPadPopup: true,
};

export const UserRoleStrings = [
  'Trial',
  'View only',
  'Upload only',
  'Limited access',
  'All access',
  'Admin access',
] as const;

export const UserStatusStrings = [
  'Deactivated',
  'Activated',
  'Pending',
  'Deleted',
] as const;

export const TemperatureStrings: Record<TemperatureKey, string> = {
  low: 'Low',
  high: 'High',
  median: 'Median',
  average: 'Average',
};

// TODO: delete this later when PanelToolbar is dead
export enum CornerPosition {
  TopLeft,
  TopRight,
  BottomRight,
  BottomLeft,
}

export const ArtifactTypeStrings = {
  [ArtifactType.Pdf]: 'PDF',
  [ArtifactType.Blob]: 'File',
  [ArtifactType.Image]: 'Image',
  [ArtifactType.Video]: 'Video',
};

export const ReportStatusStrings = {
  [ReportStatus.Draft]: 'Draft',
  [ReportStatus.Queued]: 'Processing',
  [ReportStatus.ImageProcessing]: 'Processing',
  [ReportStatus.PrintProcessing]: 'Processing',
  [ReportStatus.Failed]: 'Failed',
  [ReportStatus.Completed]: 'Completed',
} as const;
